/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-21T19:19:46-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-05-31T10:34:10-07:00
*/



import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { spacing, type, textColor } from '../../style';

const style = StyleSheet.create({

  // Sizes [1-3] corrsponds to heading sizes in HTML

  text_default: {
    ...textColor.NORMAL,
    lineHeight: '20px',
    wordBreak: 'break-word',
    ...spacing.MARGIN_BOTTOM_SM
  },

  size_SM: {
    ...type.SM
  },

  size_DEFAULT: {
    ...type.MD
  },

  size_LG: {
    ...type.LG
  },

  // whiteSpace

  preLine: {
    whiteSpace: 'pre-line'
  }



});


const Text = (props) => {
  const {
    size,
    color,
    whiteSpace,
    ...rest
  } = props;

  return (
    <div
      className={
        css(
          style.text_default,
          style[`size_${size}`],
          style[`color_${color}`],
          style[`${whiteSpace}`]
        )}
      >
      {rest.children}
    </div>
  )
}

Text.defaultProps = {
  size: 'DEFAULT',
  color: 'normal'
}

export default Text;



// WEBPACK FOOTER //
// ./src/components/common/Text.jsx